import { Box } from '@mui/material'
import { breadcrumbStyles as styles } from 'src/components/shared/Breadcrumb/BreadcrumbStyles'

type Props = {
  section: string
  subsection?: string
  children?: JSX.Element
}

export default function Breadcrumb({ section, subsection, children }: Props): JSX.Element {
  return (
    <Box component="div" sx={styles.breadcrumb} display="flex" flexDirection="row">
      {/* <Box component="span" sx={styles.base}>
        LEX-ON
      </Box> */}
      <Box component="span" sx={styles.section} flex="1 1 auto" alignSelf="flex-end">
        {section}
      </Box>
      {subsection && (
        <>
          <span>|</span>
          <Box
            component="span"
            sx={styles.subsection}
            dangerouslySetInnerHTML={{ __html: subsection }}
          />
        </>
      )}
      {children}
    </Box>
  )
}
